const TickIcon = (props) => {
    return (
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300.88 219.36"><path d="m300.88,26c0,6.95-2.7,13.47-7.62,18.38L125.9,211.75c-4.91,4.91-11.44,7.61-18.38,7.61s-13.47-2.7-18.39-7.61L7.61,130.23c-4.91-4.91-7.61-11.44-7.61-18.39s2.7-13.47,7.61-18.38c4.91-4.91,11.44-7.62,18.39-7.62s13.47,2.71,18.38,7.62l63.14,63.13L256.5,7.62c4.91-4.92,11.44-7.62,18.38-7.62s13.48,2.7,18.39,7.62c4.91,4.91,7.61,11.44,7.61,18.38Z"/></svg>  )}
    
  export default TickIcon
  